import { StyleSheet } from '@react-pdf/renderer';

const defaultStyles = StyleSheet.create({
    page: {
        flexDirection: 'row'
    },
    table: {
        display: 'table',
        borderStyle: 'solid',
        borderColor: 'black',
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
        marginBottom: 10,
        tableLayout: 'fixed'
    },
    tableCover: {
        // display: 'table',
        borderColor: 'black',
        borderStyle: 'solid',
        maxWidth: '120px',
        marginTop: '1px'
    },
    logo: {
        marginTop: '30px',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '25%'
    },
    logo_header: {
        marginTop: '10px',
        display: 'display',
        marginLeft: '10px',
        width: '25%'
    },
    title: {
        marginTop: '10px',
        textSlign: 'center',
        fontSize: '14px',
        width: '300px'
    },
    title_header: {
        marginTop: '1px',
        textSlign: 'center',
        fontSize: '6px',
        width: '100px',
        marginLeft: '0px'
    },
    pageNumbers: {
        position: 'absolute',
        width: '100%',
        bottom: '0',
        textAlign: 'center',
        fontSize: '8px',
        marginTop: '10px'
    },
    tableHeader: {
        margin: 0,
        marginTop: 0.5,
        marginBottom: 0.5,
        marginLeft: 0,
        marginRight: 0,
        textAlign: 'left',
        maxWidth: '150px',
        fontSize: '8px',
        // height: '10px',
        fontWeight: 'bold'
    },
    tableCell: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        textAlign: 'left',
        maxWidth: '120px',
        fontSize: '8px',
        paddingLeft: '0px'
    },
    button: {
        display: 'inline-block',
        padding: '15px 25px',
        fontSize: '24px',
        cursor: 'pointer',
        textAlign: 'center',
        textDecoration: 'none',
        outline: 'none',
        color: '#fff',
        backgroundColor: '#4CAF50',
        border: 'none',
        borderRadius: '15px',
        boxShadow: '0 9px #999'
    },
    white: {
        display: 'flex',
        width: '7px',
        height: '7px',
        margin: '1.5px',
        backgroundColor: '#FFF'
    },
    print_date: {
        marginTop: '1px',
        textSlign: 'center',
        fontSize: '12px',
        width: '100px',
        marginLeft: '0px'
    }
});

export default defaultStyles;
